module.exports = __webpack_public_path__ + "static/media/roundClose-img.a0fa7f80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/roundClose-img.svg
// module id = 889
// module chunks = 0